import { FC, Ref, forwardRef, useImperativeHandle, useState } from 'react';
import TableList from './components/TableList';
import { getShopExpandRecord } from '@/common/api/expandStore/shop';
import { useMethods } from '@lhb/hook';
import V2Title from '@/common/components/Feedback/V2Title';

interface DetailRecordProps {
  detail: any;
  reload?: any;
  expansionTaskAlias: string;
  ref?: Ref<any>
}

/**
 * @Description 拓店日志
 */
const DetailRecord: FC<DetailRecordProps> = forwardRef(({ detail, expansionTaskAlias }, ref) => {
  const [filters, setFilters] = useState<{ [x: string]: any }>({});// 查询条件
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false);// 是否需要当前页刷新

  useImperativeHandle(ref, () => ({
    init
  }));
  // 刷线
  const init = () => {
    methods.reload();
  };

  const methods = useMethods({
    // 搜索
    onSearch: (values: { [x: string]: string }) => {
      setFilters({ ...values });
    },

    /**
     * @description 当前页重新加载
     */
    currentReload() {
      setRefreshCurrent(true);
      setFilters({ ...filters });
    },

    /**
     * @description 从1页重新加载
     */
    reload() {
      setRefreshCurrent(false);
      setFilters({ ...filters });
    },

    loadData: async (params: any) => { // 初始化
      const _params = {
        id: detail.id,
        ...params
      };

      const data = await getShopExpandRecord(_params);
      const { objectList } = data;

      return {
        dataSource: objectList,
        count: data.totalNum,
      };

    },
  });

  return (
    <>
      <V2Title type='H2' text={`${expansionTaskAlias || '拓店'}日志`} divider style={{ marginBottom: '16px' }}/>
      <TableList
        mainHeight={521}
        filters={filters}
        onFetch={methods.loadData as any}
        refreshCurrent={refreshCurrent}
      />
    </>
  );
});

export default DetailRecord;
